var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',[_vm._l((_vm.getList(_vm.listType)),function(p){return [_c('v-list-item',{key:p.id},[_c('Publication',{attrs:{"publicationData":p}})],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }